import { Button } from 'lincd-mui-base/components/Button';
import { ImageObject } from 'lincd-schema/shapes/ImageObject';
import { getResizedImagePath } from 'lincd-server-utils/utils/ImageResize';
import { QResult } from 'lincd/queries/SelectQuery';
import { cl } from 'lincd/utils/ClassNames';
import { asset } from 'lincd/utils/LinkedFileStorage';
import { replaceLocalhostWithSiteRoot } from 'profile-pics/utils/helper';
import * as React from 'react';
import style from './ConferenceCard.module.css';

//This props probably can be modified in the future
interface ConferenceCardProps {
  id: string;
  name: string;
  buttonText?: string;
  bottomSection?: boolean;
  description?: string;
  image?: QResult<ImageObject, { contentUrl: string }> | null;
  thumbnailWidth?: number;
  thumbnailHeight?: number;
  onClick?: () => void;
  loading?: boolean;
}

function ConferenceCard({
  id,
  name,
  buttonText,
  bottomSection,
  description,
  image,
  thumbnailWidth,
  thumbnailHeight,
  onClick,
  loading,
}: ConferenceCardProps) {
  // change path to use resize image path
  const imageSrc = getResizedImagePath(
    replaceLocalhostWithSiteRoot(image?.contentUrl),
    thumbnailWidth ? thumbnailWidth * 2 : NaN,
    thumbnailHeight ? thumbnailHeight * 2 : thumbnailWidth ? NaN : 300
  );

  return (
    <div
      className={cl(
        style.MainCard,
        bottomSection && style.withFooter,
        loading && style.disabled
      )}
      onClick={onClick}
      key={id}
    >
      <div className={style.Card}>
        <div className={style.CardImage}>
          {image?.contentUrl && <img src={imageSrc} />}
        </div>
        <div className={style.HCardContent}>
          <div
            className={cl(
              style.HCardDescription,
              description && style.withDescription
            )}
          >
            <h3>{name}</h3>
            {description ? <p>{description}</p> : null}
          </div>
          <Button className={style.HCardButton}>
            <img src={asset('/images/icons/ArrowIcon.svg')} alt="Card Button" />
            {buttonText ? <p>{buttonText}</p> : null}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConferenceCard;
